// = Libs =
import React, { FC } from 'react';

// = Styles =
import classes from './list-preview.module.scss';
import Icon from '@/common/components/ui/icon/icon';
import { ListPreviewProps } from '@/pages/home/list-preview/list-preview.types';
import { mapToExecutorCard, usePollList } from '@/services/poll.service';
import { PollCardTypes } from '@/components/poll-card/poll-card.types';
import { PollCard } from '@/components/poll-card/poll-card';

const ListPreview: FC<ListPreviewProps> = ({
  url = '',
  fetchConfig = {
    limit: 2,
    offset: 0,
    mode: 'executor',
    mapping: mapToExecutorCard,
  },
  title = '',
  forceMore = false,
}) => {
  const elementList = usePollList(fetchConfig)?.elementList;

  return (
    <div>
      <a href={url}>
        <h3 className={classes.title}>{title}</h3>
      </a>
      <div className={classes.list}>
        <div className={classes.cards}>
          {elementList?.map((item: PollCardTypes.PollCardModel) => {
            return (
              <PollCard
                {...item}
                className={classes.card}
                orgId={fetchConfig.orgId}
              />
            );
          })}
          {elementList?.length < 1 && (
            <div className={classes.placeholder}>
              <p>Мониторингов пока нет</p>
            </div>
          )}
          {fetchConfig.mode === 'author' && (
            <a
              href={`/polls/author/${fetchConfig.orgId}/new`}
              className={classes.create}>
              <Icon type={'plus'} />
              <p>Создать</p>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListPreview;
